<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>能耗分析</el-breadcrumb-item>
			<el-breadcrumb-item>分级分时统计</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
			<el-form-item label="搜索：">
				<el-popover v-model="visible">
					<el-input ref="deptInput" class="cp" readonly slot="reference" autosize size="small"  placeholder="选择部门/集中器"
					 v-model="getJZ"></el-input>
					<div >
						<el-tree v-loading="treeLoad" :data="treeDate" :expand-on-click-node="false" :highlight-current="true"
						 @node-click="handleNodeClick" :props="jzProps" accordion node-key='id'>
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i v-if="!data.parentId && !data.isJz" class="el-icon-office-building"></i>
									<i v-if="data.parentId" class="el-icon-location-outline"></i>
									<i v-if="data.isJz" class="el-icon-coin"></i>
									{{ data.departmentName }}
								</span>
							</span>
						</el-tree>
					</div>
				</el-popover>
			</el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.energyType" placeholder="请选择" style="width: 120px;" clearable @change="getData">
          <el-option
            v-for="item in energyType"
            :key="item.id"
            :label="item.value"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.dateType"  style="width: 120px;"  @change="getDateType" >
          <el-option
            v-for="item in dateList"

            :key="item.value"
            :label="item.lable"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
         <el-date-picker
            @change="getData"
            style="width: 120px;"
            v-if="formInline.dateType == 'day'"
            size="small"
            value-format="yyyy-MM"
            v-model="formInline.monthDate"
            type="month"
            placeholder="选择月">
         </el-date-picker>
         <el-date-picker
            style="width: 120px;"
             @change="getData"
            v-if="formInline.dateType == 'month'"
            size="small"
            value-format="yyyy"
            v-model="formInline.yearDate"
            type="year"
            placeholder="选择年">
         </el-date-picker>
      </el-form-item>



		</el-form>

		<!--列表-->
		<el-table size="small" :data="dataList" highlight-current-row v-loading="loading"  :max-height="tableHeight"
		 border element-loading-text="拼命加载中" style="width: 100%;"stripe :header-cell-style="this.$store.state.headerCss">
			<el-table-column align="center" type="index" width="60" label="序号" fixed="left">
			</el-table-column>

      <el-table-column  label="用能单位" prop="terminalName" min-width="240" fixed>
      </el-table-column>
      <el-table-column :label="formInline.date" align="center">
        <el-table-column  :label="item" :prop="'dateTime'+item" v-for="item in tableLabel" :key="item" min-width="100">
        </el-table-column>

      </el-table-column>
      <el-table-column  label="合计" prop="energysSum" min-width="180"  fixed="right">
      </el-table-column>

		</el-table>
	</div>
</template>

<script>
	import { findEnergyGradedTime } from '../../api/analysisMG'
  import {getDepartmentTerminalInfoLis,getTerminalInfoByDepId} from '../../api/energyMG'
	export default {
		data(){
			return{
				dataList:[],
				formInline:{
					dateType:'day',
				  monthDate:new Date().getFullYear() + '-' +( new Date().getMonth()+1 < 10 ? '0':'' ) + (new Date().getMonth()+1),
					yearDate:"",
					terId:"",
          departmentId:"",
          energyType:15,
				},
        tableHeight: 0,
        dateList:[
          { value:'day',lable:'逐日' },
          { value:'month',lable:'逐月' },
          { value:'year',lable:'逐年' },

        ],
        getJZ:"",
        visible:false,
        loading:false,
        tableLabel:[],

        treeLoad:false,
        treeDate:[],
        energyType:[],
        jzProps: {
        	label: "departmentName",
        	children: 'deps'
        },
        user:{}

			}
		},
		created(){

      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.getJZ = this.user.departmentName
			this.getData()
      this.getJzData();
      this.$store.dispatch('getEnergyTypeConfig').then( (res) => {
      	this.energyType = res
      })
		},
    mounted() {

    	this.$nextTick(() => {


    		this.tableHeight = window.innerHeight - 175-30

    	})

    },
		methods:{
			search(){

			},

      getDateType(e){
       if(e == 'day'){
         let dateStr = new Date().getFullYear() + '-' +( new Date().getMonth()+1 < 10 ? '0':'' ) + (new Date().getMonth()+1)

         this.formInline.dateType = 'day'
         this.formInline.monthDate = dateStr
         this.formInline.yearDate = ''
       }else if( e == 'month'){

          this.formInline.dateType = 'month'
          this.formInline.monthDate = ''
          this.formInline.yearDate = new Date().getFullYear()+''
       }else{
          this.formInline.dateType = 'year'
          this.formInline.monthDate = ''
          this.formInline.yearDate = ''
       }

        this.getData()

      },
			getData(){
        this.loading = true

				findEnergyGradedTime(this.formInline).then(res => {
          this.loading = false

					if(res.status == 1){
            this.dataList = res.data.newsList
            this.tableLabel = res.data.datatimeList
           // this.setTableCol()
          }

				})
			},
      //设置动态表头
      setTableCol(){
        let l = 0
        let arr = []
        console.log(formInline.dateType)
        if( this.formInline.dateType == 'day'){
          let y = this.formInline.monthDate.substring(0,4)
          let m = this.formInline.monthDate.substring(5)

          l = new Date(y,m,0).getDate()
        }else if( this.formInline.dateType == 'month'){
          l = 12
        }else{
          console.log(Object.keys(this.dataList[0]))
          l = Object.keys(this.dataList[0]).length - 2
        }

        if( this.formInline.dateType == 'year'){
          var Year = 2019
          for( let i = 0;i< l ;i++){
            let obj = {}
            obj.lable = Year + ''
            obj.props = 'dateTime'+Year
            arr.push(obj)
            Year++
          }
        }else{
          for( let i =0;i< l;i++){
            let obj = {}
            obj.lable = (i+1)+''
            obj.props = i < 9 ? 'dateTime0'+(i+1) : 'dateTime'+(i+1)
            arr.push(obj)
          }
        }

        this.tableLabel = arr
      },






      //获取集中器信息
      getJzData: function() {
      	return new Promise((resolve, reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if (res.status == 1) {
      				this.treeDate = this.changeData(res.data.menuDepList)
              this.getTepIds(this.user.departmentId)
      			} else {
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },
      changeData(data) {
      	data.forEach(item => {
      		if (item.terminalInfo) {
      			if (!item.deps) {
      				item.deps = []
      			}
      			item.terminalInfo.forEach(sitem => {
      				let obj = {}
      				obj.id = sitem.id
      				obj.departmentName = sitem.terminalName
      				obj.terminalCode = sitem.terminalCode
      				obj.isJz = true
      				item.deps.push(obj)
      			})
      		}
      		if (item.deps) {
      			this.changeData(item.deps)
      		}
      	})

      	return data
      },
      getTepIds(id){
        // 点击部门获得集中器id
        getTerminalInfoByDepId({
        	depId: id
        }).then(res => {
        	if (res.status == 1) {
        		//this.formInline.termianlId = res.data.join('-')
        		this.getData()
        	} else {
        		this.$message.error(res.msg)
        	}
        })
      },
      handleNodeClick(data) {
       this.getJZ = data.departmentName
        if (data.isJz) {
          this.formInline.terId = data.id
          this.formInline.departmentId = ""
        } else {
           this.formInline.terId = ""
          this.formInline.departmentId = data.id
        }
        this.getData()
      	this.visible = false

      },

      rowClass(){
        return "color:#5c5c5c;background:#fff"
      },



		}
	}



</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/analysis/timeStatistics.vue